export const GET_IDENTITY_DETAILS = 'GET_IDENTITY_DETAILS'
export const CLEAR_IDENTITY_DETAILS = 'CLEAR_IDENTITY_DETAILS'
